module.exports = __webpack_public_path__ + "static/media/1010690.77c89ff6.jpg";